import { ReactElement } from 'react';

import Article from 'models/Article';

import Component from './component';

export interface Props extends ParentProps {
}

export interface IndexStructure {
    [key: number]: IndexLevel;
}

export interface IndexLevel {
    key: string;
    level: number;
    order: number;
    text: string;
    elements: IndexStructure;
}

export interface ParentProps {
    article: Article;
    children: (content: string, indexStructure: IndexStructure) => ReactElement;
}

Component.defaultProps = {};
export default Component;
